<template>
    <a target="_blank" class="group">
        <slot />
    </a>
</template>

<script>
export default {
    name: "ExternalLink"
}
</script>
